import * as React from 'react';
export const AddressEventsContext = React.createContext({
    addressEvents: [],
    status: 'UNINITIALIZED',
});
